// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AboutRouteImport } from './routes/about'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as AdminLoginRouteImport } from './routes/admin-login'
import { Route as AuditRoadmapRouteImport } from './routes/audit-roadmap'
import { Route as ClientUploadRouteImport } from './routes/client-upload'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as DashboardRouteImport } from './routes/dashboard'
import { Route as DisclaimerRouteImport } from './routes/disclaimer'
import { Route as EReturnVsPaperReturnRouteImport } from './routes/e-return-vs-paper-return'
import { Route as FaqRouteImport } from './routes/faq'
import { Route as HowItWorksRouteImport } from './routes/how-it-works'
import { Route as LoginRouteImport } from './routes/login'
import { Route as PackagesRouteImport } from './routes/packages'
import { Route as PartnersRouteImport } from './routes/partners'
import { Route as PaymentRouteImport } from './routes/payment'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as ServicesRouteImport } from './routes/services'
import { Route as SignupRouteImport } from './routes/signup'
import { Route as TaxReturnDeadlineBdRouteImport } from './routes/tax-return-deadline-bd'
import { Route as TaxReturnDocumentsBdRouteImport } from './routes/tax-return-documents-bd'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as TinCertificateBdRouteImport } from './routes/tin-certificate-bd'
import { Route as UploadRouteImport } from './routes/upload'
import { Route as VisaTaxRouteImport } from './routes/visa-tax'
import { Route as WhyChooseUsRouteImport } from './routes/why-choose-us'
import { Route as BlogIndexRouteImport } from './routes/blog.index'
import { Route as BlogSlugRouteImport } from './routes/blog.$slug'
import { Route as KnowledgeHubIndexRouteImport } from './routes/knowledge-hub.index'
import { Route as KnowledgeHubSlugRouteImport } from './routes/knowledge-hub.$slug'
import { Route as ServicesSlugRouteImport } from './routes/services_.$slug'
import { Route as DotlovableOauthConsentRouteImport } from './routes/[.]lovable.oauth.consent'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const AdminRoute = AdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => rootRouteImport
          })
const AdminLoginRoute = AdminLoginRouteImport.update({
            id: '/admin-login',path: '/admin-login',getParentRoute: () => rootRouteImport
          })
const AuditRoadmapRoute = AuditRoadmapRouteImport.update({
            id: '/audit-roadmap',path: '/audit-roadmap',getParentRoute: () => rootRouteImport
          })
const ClientUploadRoute = ClientUploadRouteImport.update({
            id: '/client-upload',path: '/client-upload',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const DashboardRoute = DashboardRouteImport.update({
            id: '/dashboard',path: '/dashboard',getParentRoute: () => rootRouteImport
          })
const DisclaimerRoute = DisclaimerRouteImport.update({
            id: '/disclaimer',path: '/disclaimer',getParentRoute: () => rootRouteImport
          })
const EReturnVsPaperReturnRoute = EReturnVsPaperReturnRouteImport.update({
            id: '/e-return-vs-paper-return',path: '/e-return-vs-paper-return',getParentRoute: () => rootRouteImport
          })
const FaqRoute = FaqRouteImport.update({
            id: '/faq',path: '/faq',getParentRoute: () => rootRouteImport
          })
const HowItWorksRoute = HowItWorksRouteImport.update({
            id: '/how-it-works',path: '/how-it-works',getParentRoute: () => rootRouteImport
          })
const LoginRoute = LoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => rootRouteImport
          })
const PackagesRoute = PackagesRouteImport.update({
            id: '/packages',path: '/packages',getParentRoute: () => rootRouteImport
          })
const PartnersRoute = PartnersRouteImport.update({
            id: '/partners',path: '/partners',getParentRoute: () => rootRouteImport
          })
const PaymentRoute = PaymentRouteImport.update({
            id: '/payment',path: '/payment',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const ResetPasswordRoute = ResetPasswordRouteImport.update({
            id: '/reset-password',path: '/reset-password',getParentRoute: () => rootRouteImport
          })
const ServicesRoute = ServicesRouteImport.update({
            id: '/services',path: '/services',getParentRoute: () => rootRouteImport
          })
const SignupRoute = SignupRouteImport.update({
            id: '/signup',path: '/signup',getParentRoute: () => rootRouteImport
          })
const TaxReturnDeadlineBdRoute = TaxReturnDeadlineBdRouteImport.update({
            id: '/tax-return-deadline-bd',path: '/tax-return-deadline-bd',getParentRoute: () => rootRouteImport
          })
const TaxReturnDocumentsBdRoute = TaxReturnDocumentsBdRouteImport.update({
            id: '/tax-return-documents-bd',path: '/tax-return-documents-bd',getParentRoute: () => rootRouteImport
          })
const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const TinCertificateBdRoute = TinCertificateBdRouteImport.update({
            id: '/tin-certificate-bd',path: '/tin-certificate-bd',getParentRoute: () => rootRouteImport
          })
const UploadRoute = UploadRouteImport.update({
            id: '/upload',path: '/upload',getParentRoute: () => rootRouteImport
          })
const VisaTaxRoute = VisaTaxRouteImport.update({
            id: '/visa-tax',path: '/visa-tax',getParentRoute: () => rootRouteImport
          })
const WhyChooseUsRoute = WhyChooseUsRouteImport.update({
            id: '/why-choose-us',path: '/why-choose-us',getParentRoute: () => rootRouteImport
          })
const BlogIndexRoute = BlogIndexRouteImport.update({
            id: '/blog/',path: '/blog/',getParentRoute: () => rootRouteImport
          })
const BlogSlugRoute = BlogSlugRouteImport.update({
            id: '/blog/$slug',path: '/blog/$slug',getParentRoute: () => rootRouteImport
          })
const KnowledgeHubIndexRoute = KnowledgeHubIndexRouteImport.update({
            id: '/knowledge-hub/',path: '/knowledge-hub/',getParentRoute: () => rootRouteImport
          })
const KnowledgeHubSlugRoute = KnowledgeHubSlugRouteImport.update({
            id: '/knowledge-hub/$slug',path: '/knowledge-hub/$slug',getParentRoute: () => rootRouteImport
          })
const ServicesSlugRoute = ServicesSlugRouteImport.update({
            id: '/services_/$slug',path: '/services/$slug',getParentRoute: () => rootRouteImport
          })
const DotlovableOauthConsentRoute = DotlovableOauthConsentRouteImport.update({
            id: '/.lovable/oauth/consent',path: '/.lovable/oauth/consent',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,AboutRoute: AboutRoute,AdminRoute: AdminRoute,AdminLoginRoute: AdminLoginRoute,AuditRoadmapRoute: AuditRoadmapRoute,ClientUploadRoute: ClientUploadRoute,ContactRoute: ContactRoute,DashboardRoute: DashboardRoute,DisclaimerRoute: DisclaimerRoute,EReturnVsPaperReturnRoute: EReturnVsPaperReturnRoute,FaqRoute: FaqRoute,HowItWorksRoute: HowItWorksRoute,LoginRoute: LoginRoute,PackagesRoute: PackagesRoute,PartnersRoute: PartnersRoute,PaymentRoute: PaymentRoute,PrivacyRoute: PrivacyRoute,ResetPasswordRoute: ResetPasswordRoute,ServicesRoute: ServicesRoute,SignupRoute: SignupRoute,TaxReturnDeadlineBdRoute: TaxReturnDeadlineBdRoute,TaxReturnDocumentsBdRoute: TaxReturnDocumentsBdRoute,TermsRoute: TermsRoute,TinCertificateBdRoute: TinCertificateBdRoute,UploadRoute: UploadRoute,VisaTaxRoute: VisaTaxRoute,WhyChooseUsRoute: WhyChooseUsRoute,BlogSlugRoute: BlogSlugRoute,KnowledgeHubSlugRoute: KnowledgeHubSlugRoute,ServicesSlugRoute: ServicesSlugRoute,BlogIndexRoute: BlogIndexRoute,KnowledgeHubIndexRoute: KnowledgeHubIndexRoute,DotlovableOauthConsentRoute: DotlovableOauthConsentRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)